<template>
	<div class="flex items-center">
		{{ golfRound.gross_score }}
		<span
			class=" ml-2"
			:class="{'bg-red-600 text-white p-1 rounded-md': golfRound.to_par < 0, 'bg-black text-white p-1 rounded-md': golfRound.to_par > 0}"
		>({{ golfRound.current_score }})</span>
	</div>
</template>
<script>
/** @format */

export default {
	name: 'GolfScoreGraphic',
	props: {
		golfRound: {
			type: Object,
			required: true
		}
	}
};
</script>
